import { useTranslation } from 'react-i18next';
import { TeContainer, TeGrid } from '@topcon/tuicl-react';

import { Section } from '../../utils/styling';
import Header from '../../components/Header';
import Card from '../../components/Card';
import { AppRoutes } from '../../app/routes/utils';
import featureFlags from '../../utils/featureFlags';
import { useMigrationCandidateBusinessPartners } from '../../hooks/queries/migration.queries';

function Companies() {
  const { t } = useTranslation('companies');
  const { data: migrationCandidates } = useMigrationCandidateBusinessPartners();

  const showUnclaimedOrganizations =
    featureFlags.MIGRATION && !!migrationCandidates?.items && migrationCandidates.items.length > 0;

  const renderSettings = () => {
    return (
      <>
        <Card
          icon="domain"
          title={t('list.title')}
          description={t('list.description')}
          buttonText={t('list.buttonText')}
          route={{ to: AppRoutes.CompaniesList }}
        />
        <Card
          icon="drafts"
          title={t('inviteSection.title')}
          description={t('inviteSection.description')}
          buttonText={t('inviteSection.buttonText')}
          route={{ to: AppRoutes.Invites }}
        />
        <Card
          icon="concierge"
          title={t('joinRequests.title')}
          description={t('joinRequests.description')}
          buttonText={t('joinRequests.buttonText')}
          route={{ to: AppRoutes.JoinRequests }}
        />
        {showUnclaimedOrganizations && (
          <Card
            icon="auto_awesome"
            title={t('pendingMerges.title')}
            description={t('pendingMerges.description')}
            buttonText={t('pendingMerges.buttonText')}
            route={{ to: AppRoutes.UnclaimedOrganizations }}
          />
        )}
      </>
    );
  };

  return (
    <TeContainer column grow gap="xs" padding="xs" overflow="auto" alignItems="center">
      <Header text={t('title')} />
      <Section>
        <TeGrid gap="s">{renderSettings()}</TeGrid>
      </Section>
    </TeContainer>
  );
}

export default Companies;
